import React from 'react'
import { SvgIconProps } from './Home'

const SvgCheckInIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="32"
    fill="none"
    viewBox="0 0 48 32"
  >
    <path
      fill={fill ?? "#353535"}
      d="M1.398 31.036c3.195.675 6.59.964 10.084.964 3.495 0 6.89-.386 10.085-.964.798-.193 1.397-.964 1.297-1.735l-.798-6.265c-.5-3.855-3.894-6.747-7.888-6.747H8.687c-3.994 0-7.389 2.892-7.888 6.747L0 29.301c0 .771.6 1.542 1.398 1.735zM11.482 14.458c4.136 0 7.489-3.237 7.489-7.23C18.97 3.238 15.618 0 11.482 0 7.346 0 3.994 3.237 3.994 7.229s3.352 7.229 7.488 7.229zM46.216 8.938l1.512 1.459a.874.874 0 010 1.268L35.552 23.42a.952.952 0 01-1.314 0l-6.009-5.801a.874.874 0 010-1.268l1.511-1.46a.952.952 0 011.314 0l3.84 3.707 10.008-9.662a.954.954 0 011.314.002z"
    ></path>
  </svg>
)


export default SvgCheckInIcon